var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rt-container mobile-matrix-scale" },
    _vm._l(_vm.table.rows, function (row) {
      return _c(
        "div",
        { key: row.id, staticClass: "card" },
        [
          _c("van-cell", {
            staticClass: "block-title",
            attrs: { title: row.label },
          }),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("el-rate", {
                staticClass: "rate",
                attrs: {
                  "icon-classes": [_vm.icon, _vm.icon, _vm.icon],
                  colors: [_vm.iconColor, _vm.iconColor, _vm.iconColor],
                  max: _vm.table.level,
                  "void-icon-class": _vm.icon,
                  "disabled-void-icon-class": _vm.icon,
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.dataValue[row.id],
                  callback: function ($$v) {
                    _vm.$set(_vm.dataValue, row.id, $$v)
                  },
                  expression: "dataValue[row.id]",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }